import { render, staticRenderFns } from "./CampoDeFornecedorNaEmissaoDeNota.vue?vue&type=template&id=66940119&scoped=true&"
import script from "./CampoDeFornecedorNaEmissaoDeNota.vue?vue&type=script&lang=ts&"
export * from "./CampoDeFornecedorNaEmissaoDeNota.vue?vue&type=script&lang=ts&"
import style0 from "./CampoDeFornecedorNaEmissaoDeNota.vue?vue&type=style&index=0&id=66940119&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66940119",
  null
  
)

export default component.exports